
export default {
  name: 'OnboardingHandIcon',
};
